export const dashboardEn = {};

export const dashboardFr = {};
